<template>
  <div class="container">
    <div class="icon-header-container">
      <h1 class="principal-page-title principal-page-title-account">
        Devolución Impuestos
      </h1>
    </div>

    <div class="form-row packages-form flex-row">
      <div class="row">
        <div class="col-md-12">
          <form-wizard ref="wizard" @on-complete="onComplete" title="" subtitle="" :back-button-text="'Volver'" :next-button-text="'Siguiente'" :finish-button-text="'Finalizar'">
            <tab-content title="Número de Orden">
              <div class="order-id-container">
                <small class="text-muted d-block mb-3">
                  Siga estos pasos para encontrar su número de orden en Amazon:
                </small>
                <ol class="small mb-4 ps-3">
                  <li>Ingrese a su cuenta de Amazon.</li>
                  <li>Vaya al menú “Mis pedidos”.</li>
                  <li>Ubique la compra correspondiente.</li>
                  <li>El número de orden se encuentra cerca del título “PEDIDO N°”.</li>
                </ol>
                
                <img src="https://crbox.cr/wp-content/uploads/2025/05/amazon-order.82a96466.png" alt="Amazon Order Number" class="mb-4">
                
                <label class="mb-2">Ingrese el Número de Orden de Amazon</label>
                <input v-model="formData.amazonOrderId" placeholder="Número de Orden de Amazon" class="form-control" />
                
                <label class="mb-2 mt-4">Descripción en prosa de los artículos seleccionados</label>
                <textarea rows="7" v-model="formData.selectedArticlesDescription" placeholder="Para la orden ingresada se seleccionaron una camiseta azul..." class="form-control" />
              </div>
            </tab-content>

            <tab-content title="Detalle de la Orden">
              <div class="box">
                <h3>Detalle de la orden seleccionada</h3>
                <p><strong>#MAWB:</strong> {{this.packageData.masterAirShipmentNumber}}</p>
                <p><strong>#HAWB:</strong> {{this.packageData.airShipmentNumber}}</p>
                <p><strong>Número de recibo:</strong> {{this.packageData.number}}</p>
                <p><strong>Carrier:</strong> {{this.packageData.carrierName}}</p>
                <p><strong>Número de Tracking:</strong> {{this.packageData.trackingNumber}}</p>
                <p><strong>Envia:</strong> {{this.packageData.shipperName}}</p>
                <p><strong>Pieza/s:</strong> {{this.packageData.totalpieces}}</p>
                <p><strong>Peso (En Volumen):</strong> {{this.packageData.totalvolumetricweight}}</p>
                <p><strong>Peso (En Kilogramos):</strong> {{this.packageData.totalweight}}</p>
                <p><strong>Notas:</strong> {{this.packageData.consigneeNotes}}</p>
              </div>
            </tab-content>

            <tab-content title="Descargar PDF">
              <div v-if="!formData.amazonOrderId && !this.downloadSuccess" class="box danger">
                <h4>
                  No se puede descargar el documento PDF hasta que no complete el campo del número de orden de Amazon.
                </h4>
              </div>

              <div v-else>
                <div v-if="downloadSuccess === true" class="box success">
                  <h4>
                    El PDF ha sido descargado con éxito. No olvide adjuntarlo al correo.
                  </h4>
                </div>
                <div v-else-if="downloadSuccess === false" class="box danger">
                  <h4>
                    No se ha podido descargar el PDF. Intente de nuevo.
                  </h4>
                </div>
                <div v-else class="box">
                  <h4>El documento se generará al hacer clic en "Finalizar".</h4>
                </div>
              </div>
            </tab-content>
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'

export default {
  name: "TaxRefund",
  components: {
    FormWizard,
    TabContent,
  },
  data() {
    return {
      formData: {
        amazonOrderId: "",
        selectedArticlesDescription: "",
      },
      idwarehousereceipt: '',
      isDownloading: false,
      downloadSuccess: null,
      packageData: null,
    };
  },
  methods: {
    async onComplete() {
      if (!this.formData.amazonOrderId) {
        Swal.fire({
          title: 'Falta número de orden',
          text: 'Debes ingresar el número de orden de Amazon antes de continuar.',
        });

        return;
      }

      if (!this.formData.selectedArticlesDescription) {
        Swal.fire({
          title: 'Falta ingresar la descripción de la orden',
          text: 'Debes ingresar una breve descripción en prosa de los artículos seleccionados antes de continuar.',
        });

        return;
      }

      try {
        this.isDownloading = true;
        this.downloadSuccess = null;

        const loadingAlert = Swal.fire({
          title: 'Descargando...',
          text: 'Por favor espere mientras se genera el documento PDF.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const url = `https://clients.crbox.cr/api/crboxwebapi/amazontaxreturnpdf/${this.idwarehousereceipt}/${this.formData.amazonOrderId}`;

        const response = await fetch(url, {
          method: 'GET',
        });

        if (!response.ok) throw new Error('Error en la respuesta de red');

        const blob = await response.blob();
        const downloadUrl = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = `receipt-${this.formData.amazonOrderId}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(downloadUrl);

        this.downloadSuccess = true;

        Swal.fire({
          title: 'Descarga completa',
          text: 'El documento PDF se descargó correctamente.',
        });

        // Mailto
        const email = 'tax-exempt@amazon.com';
        const subject = encodeURIComponent("REEMBOLSO DE TAX " + this.formData.amazonOrderId);
        const body = encodeURIComponent(
          `Buenas tardes,\n\nAdjunto documento donde se evidencia que mi paquete con número de orden ${this.formData.amazonOrderId} fue entregado a mi persona.`
        );

        const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
        window.location.href = mailtoLink;

        this.formData.amazonOrderId = '';
      } catch (error) {
        console.error("Error downloading PDF:", error);
        this.downloadSuccess = false;

        Swal.fire({
          title: 'Error al descargar',
          text: 'No se ha podido descargar el documento PDF. Intenta de nuevo.',
        });
      } finally {
        this.isDownloading = false;
      }
    }
  },
  created() {
    if (this.$route && this.$route.query) {
      const { idwarehousereceipt } = this.$route.query;

      if (idwarehousereceipt) {
        this.idwarehousereceipt = idwarehousereceipt
      }
    }

    const storedPackage = localStorage.getItem('selectedPackage');
    if (storedPackage) {
      this.packageData = JSON.parse(storedPackage);
    } else {
      console.log('No hay paquete seleccionado en localStorage');
    }
  },
};
</script>
<style lang="css" scoped>
  .order-id-container {
    max-width: 550px;
    margin: 20px auto;
  }

  .order-id-container h4 {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
  }

  .box {
    max-width: 550px;
    border-width: 2px;
    border-style: solid;
    border-radius: 12px;
    margin: 20px auto;
    font-weight: bold;
    padding: 16px 32px;
  }

  .box h4 {
    text-align: center;
    margin-bottom: 0;
  }

  .success {
    border-color: #008000;
    background-color: #77ff7798;
  }

  .success h4 {
    color: black !important;
  }

  .danger {
    border-color: #ff0000;
    background-color: #e74c3c;
  }

  .danger h4 {
    color: white !important;
  }
</style>